/**
 * BSS B2B Staffelpreis Sync v16
 *
 * Zeigt "Gesamtpreis = BSS-Stückpreis × QTY" oben am Produkttitel.
 * - Liest Stückpreis aus aktiver BSS-Tier-Zeile
 * - Liest QTY aus Input
 * - Schreibt Total ins [bss-b2b-product-price] Element
 * - Polling + Events (robust gegen BSS-Eingriffe)
 */
(function () {
  'use strict';

  function parsePriceCents(text) {
    if (!text) return null;
    // Match: €1.234,56  €12,34  €1234,56  (with or without thousands separator)
    var m = text.match(/[\u20ac]\s*(\d{1,3}(?:[.\s]\d{3})*|\d+)[,.](\d{2})/);
    if (!m) return null;
    var whole = m[1].replace(/[.\s]/g, ''); // strip thousands separators
    var cents = m[2];
    var val = parseFloat(whole + '.' + cents);
    if (isNaN(val) || val <= 0) return null;
    return Math.round(val * 100);
  }

  function formatPrice(cents) {
    var euro = (cents / 100).toFixed(2);
    var parts = euro.split('.');
    // Add thousands separator (.) to integer part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20ac' + parts[0] + ',' + parts[1];
  }

  function getContext(el) {
    if (!el) return null;
    if (el.closest('#Cart-Drawer') || el.closest('.thb-cart-form') ||
        el.closest('[id^="CartDrawerItem"]') || el.closest('.cart-drawer') ||
        el.closest('cart-drawer')) return 'cart';
    if (el.closest('.product-modal') || el.closest('modal-dialog')) return 'quickview';
    return 'pdp';
  }

  var TABLE_SEL = '.bss-b2b-cart-item-qty-table, .bss-b2b-qb-table, .bss-b2b-qb-table-on-quick-view';

  // ── Read tiers ────────────────────────────────────────────────────────────

  function readTiers(tableEl) {
    var tiers = [];
    tableEl.querySelectorAll('tr.bss-b2b-qty-table-row, tr[data-min]').forEach(function (row) {
      var min = parseInt(row.getAttribute('data-min'), 10);
      var cells = row.querySelectorAll('td');
      if (!min || cells.length < 2) return;
      var unitSpan = cells[1].querySelector('.bss-b2b-price-has-vat');
      var unit = parsePriceCents(unitSpan ? unitSpan.textContent : cells[1].textContent);
      if (!unit) return;
      // Read Total from column 2 (BSS calculated brutto total at tier-min qty)
      var totalCents = null;
      if (cells.length >= 3) {
        var totalSpan = cells[2].querySelector('.bss-b2b-price-has-vat');
        totalCents = parsePriceCents(totalSpan ? totalSpan.textContent : cells[2].textContent);
      }
      tiers.push({ min: min, unit: unit, total: totalCents });
    });
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }

  function tierForQty(tiers, qty) {
    var match = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min) match = tiers[i];
    }
    return match;
  }

  // ── Find qty input scoped to the table's context ──────────────────────────

  function findInput(tableEl, ctx) {
    if (ctx === 'cart') {
      var ci = tableEl.closest('.product-cart-item') || tableEl.closest('tr');
      return ci ? ci.querySelector('input.qty, input[name="updates[]"]') : null;
    }
    if (ctx === 'quickview') {
      var modal = tableEl.closest('.product-modal') || tableEl.closest('modal-dialog');
      return modal ? modal.querySelector('input.qty, input[name="quantity"]') : null;
    }
    var all = document.querySelectorAll('input.qty, input[name="quantity"]');
    for (var i = 0; i < all.length; i++) {
      if (getContext(all[i]) === 'pdp') return all[i];
    }
    return null;
  }

  // ── Price scope ───────────────────────────────────────────────────────────

  function getPriceScope(tableEl, ctx) {
    if (ctx === 'quickview') {
      return tableEl.closest('.product-modal') || tableEl.closest('modal-dialog') || document;
    }
    return document;
  }

  // ── Update BSS price element with "Total (unit × qty)" ───────────────────

  function updatePrice(tableEl, ctx, qty, tier) {
    // Scale BSS's brutto total proportionally (preserves their exact rounding)
    var totalCents;
    if (tier.total && tier.min > 0) {
      totalCents = Math.round(tier.total / tier.min * qty);
    } else {
      totalCents = tier.unit * qty;
    }
    var unitCents = tier.unit;

    if (ctx === 'cart') {
      var cartItem = tableEl.closest('.product-cart-item');
      if (!cartItem) return;
      cartItem.querySelectorAll('[bss-b2b-final-line-price] ins .amount, [bss-b2b-final-line-price] .amount')
        .forEach(function (e) { e.textContent = formatPrice(totalCents); });
      return;
    }

    var scope = getPriceScope(tableEl, ctx);
    var priceEl = scope.querySelector('[bss-b2b-product-price]');
    if (!priceEl) return;

    // Overwrite BSS's own price display: show Total in main, unit breakdown as small text
    priceEl.innerHTML =
      '<ins><span class="amount" style="font-size:inherit">' + formatPrice(totalCents) + ' inkl. MwSt.</span></ins>' +
      '<small style="display:block;font-size:0.85rem;color:#666;font-weight:400;margin-top:2px">' +
      '(' + formatPrice(unitCents) + ' / St\u00fcck \u00d7 ' + qty + ')</small>';
  }

  // ── Sync logic ────────────────────────────────────────────────────────────

  function watchTable(tableEl) {
    if (tableEl._cerionV16) return;
    tableEl._cerionV16 = true;

    var ctx = getContext(tableEl);
    var lastKey = '';

    function sync() {
      // Skip if this table is no longer visible (variant changed)
      if (!isVisible(tableEl) && !isVisible(tableEl.parentElement)) return;
      var tiers = readTiers(tableEl);
      if (!tiers.length) return;
      var input = findInput(tableEl, ctx);
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (qty <= 0) return;
      var tier = tierForQty(tiers, qty);
      if (!tier) return;
      var key = qty + ':' + tier.unit + ':' + tier.total;
      if (key === lastKey) return;
      lastKey = key;
      updatePrice(tableEl, ctx, qty, tier);
    }

    // Attach input listeners
    function attachInput() {
      var input = findInput(tableEl, ctx);
      if (!input || input._cerionV16) return;
      input._cerionV16 = true;
      ['change', 'input', 'keyup'].forEach(function (evt) {
        input.addEventListener(evt, function () { setTimeout(sync, 30); });
      });
    }

    // BSS table click
    tableEl.addEventListener('click', function () {
      lastKey = '';
      setTimeout(sync, 50);
      setTimeout(sync, 250);
    });

    // Show loading immediately (BEFORE theme re-renders the price)
    function showLoading() {
      var scope = getPriceScope(tableEl, ctx);
      var priceEl = scope.querySelector('[bss-b2b-product-price]');
      if (priceEl) {
        priceEl.innerHTML = '<ins><span class="amount" style="font-size:inherit;opacity:0.5">\u2026</span></ins>';
      }
      lastKey = '';
    }

    // Intercept variant changes at capture phase (fires BEFORE theme's onVariantChange)
    function attachVariantCaptureListener() {
      var scope = (ctx === 'quickview')
        ? (tableEl.closest('.product-modal') || tableEl.closest('modal-dialog'))
        : document;
      if (!scope) return;
      var selectors = scope.querySelectorAll('variant-radios, variant-selects, product-form');
      selectors.forEach(function (el) {
        if (el._cerionVariantWatch) return;
        el._cerionVariantWatch = true;
        // Capture phase: runs BEFORE theme's change handler
        el.addEventListener('change', showLoading, true);
        // Also click for radio swatches
        el.addEventListener('click', function (e) {
          if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL' ||
                           e.target.closest('input[type="radio"]') || e.target.closest('label'))) {
            showLoading();
          }
        }, true);
      });
    }
    attachVariantCaptureListener();
    setTimeout(attachVariantCaptureListener, 500);
    setTimeout(attachVariantCaptureListener, 1500);

    // Also hook into variant-change event as fallback
    document.addEventListener('product:variant-change', function () {
      lastKey = '';
      setTimeout(sync, 50);
      setTimeout(sync, 200);
      setTimeout(sync, 500);
      setTimeout(sync, 1000);
    });

    // Also watch price element for theme overwrites (ignore our own writes)
    var scope = getPriceScope(tableEl, ctx);
    var priceEl = scope.querySelector('[bss-b2b-product-price]');
    if (priceEl) {
      var ownWrite = false;
      var origUpdate = updatePrice;
      // Wrap sync to mark our own writes
      var originalSync = sync;
      sync = function () {
        ownWrite = true;
        originalSync();
        setTimeout(function () { ownWrite = false; }, 50);
      };
      new MutationObserver(function () {
        if (ownWrite) return;
        lastKey = '';
        setTimeout(sync, 30);
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Polling: catches .value sets without events + BSS rendering delays
    var poll = setInterval(sync, 200);
    // Stop polling after 2 minutes to save resources (event listeners remain)
    setTimeout(function () { clearInterval(poll); }, 120000);

    // Initial + retries for dynamic content
    attachInput();
    setTimeout(function () { attachInput(); sync(); }, 100);
    setTimeout(function () { attachInput(); sync(); }, 500);
    setTimeout(function () { attachInput(); sync(); }, 1500);
  }

  // ── VPE Step ──────────────────────────────────────────────────────────────

  function enforceStep(tableEl) {
    var ctx = getContext(tableEl);
    if (ctx === 'cart') return;
    var tiers = readTiers(tableEl);
    if (!tiers.length) return;
    var step = tiers[0].min;
    var input = findInput(tableEl, ctx);
    if (!input) return;
    if ((parseInt(input.getAttribute('step'), 10) || 1) !== step) {
      input.setAttribute('min', String(step));
      input.setAttribute('step', String(step));
    }
  }

  // ── Cart header mirror ────────────────────────────────────────────────────

  function syncCartHeader() {
    var el = document.querySelector('[bss-b2b-cart-total-price] .amount, [bss-b2b-cart-total-price]');
    if (!el) return;
    var t = el.textContent.trim();
    if (t) document.querySelectorAll('.thb-secondary-area--item-amount')
      .forEach(function (e) { e.textContent = '(' + t + ')'; });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  function initTables() {
    document.querySelectorAll(TABLE_SEL).forEach(function (wrapper) {
      var t = wrapper.querySelector('table.quantity_break_table, table');
      var el = (t && t.querySelector('tr')) ? t : wrapper;
      if (!el.querySelector('tr')) return;
      // Only watch visible tables (BSS renders hidden tables per variant)
      if (!isVisible(el) && !isVisible(wrapper)) return;
      watchTable(el);
      enforceStep(el);
    });
  }

  function init() {
    initTables();
    new MutationObserver(initTables).observe(document.body, { childList: true, subtree: true });
    setTimeout(initTables, 500);
    setTimeout(initTables, 1500);
    setTimeout(initTables, 3000);

    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle) toggle.addEventListener('click', function () { setTimeout(syncCartHeader, 300); });
    var dt = document.querySelector('[bss-b2b-cart-total-price]');
    if (dt) new MutationObserver(syncCartHeader).observe(dt, { subtree: true, childList: true, characterData: true });
    setTimeout(syncCartHeader, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();